import { memo, useEffect, useState, useContext, useRef } from 'react';
import { Input } from "../components/Form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import TextTruncate from 'react-text-truncate';
import { useCookies } from 'react-cookie'
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import { useGoogleLogin } from '@react-oauth/google';

import { Config } from '../../inc/Config'
import { AppContext } from "../../Context";
import {  user_login } from "../inc/Fetch";
import NumberCart from "./product/Number";

import { MdAddShoppingCart, MdOutlineShoppingCart } from "react-icons/md";
import { GoCheckCircleFill, GoCircle, GoTriangleDown } from "react-icons/go";

import Google from '../assets/google.png'

export function LanguageSelect() {

    const [cookies, setCookie] = useCookies(['lang']);

    const {language} = useContext(AppContext);
    const [lang, setlang] = language;

    const [langMenu, setlangMenu] = useState(false);

    function changeLang(la) {
        let expires = new Date()
        expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000))


        setCookie('lang', la, { path: '/',  expires});
        window.location.reload();
        // setlang(la);
        setlangMenu(false);
    }

    return (
        <ul className='languageSelectBox'>
            <li onClick={() => setlangMenu(p => !p)}>{lang} <GoTriangleDown /></li>
            <template className={langMenu ? "open" : undefined}>
                <a onClick={() => changeLang("EN")}>English</a>
                <a onClick={() => changeLang("AR")}>العربية</a>
            </template>
            
        </ul>
    );
}

export function VideoPlayer({src, className, controls}) {

    if (!src) {
        return false;
    } else {
        return (
            <video className={`videoPlayer ${className}`} playsInline muted autoPlay loop controls={controls || false}>
                <source src={`${Config?.imgUrl}/${src}`} type="video/mp4"></source>
            </video>
            // <img src={Config?.imgUrl + `${size}/` + src} style={style} />
        );
    }
    
}

export function Img({src, className, style, load, onClick}) {

    if (!className) {
        className = "";
    }
    
    const addDefaultImg = ev => {
        // ev.target.src = `${Config?.imgUrl}Files/nopic.jpg`
    }

    if (!src || src?.indexOf("undefined") > -1) {
        return (
            <LazyLoadImage 
                onClick={onClick}
                src={`${Config?.imgUrl}Files/nopic.jpg`}
                style={style} 
                alt="Image Alt"
                className={`imgPlug ${className}`}
                visibleByDefault={load || false}
                effect="blur"
                
            />
        );
    } else {

        if (src?.indexOf("https://") > -1 || src?.indexOf("http://") > -1) {
            return (
                <LazyLoadImage 
                    onError={addDefaultImg}
                    onClick={onClick}
                    src={`${src}`}
                    style={style} 
                    alt="Image Alt"
                    className={`imgPlug ${className}`}
                    visibleByDefault={load || false}
                    effect="blur"
                />
            );

        } else if (src?.indexOf("static/media/") > -1) {

            return (
                <LazyLoadImage 
                    onError={addDefaultImg}
                    onClick={onClick}
                    src={`${src}`}
                    style={style} 
                    alt="Image Alt"
                    className={`imgPlug ${className}`}
                    visibleByDefault={load || false}
                    effect="blur"
                />
            );

        } else {

            return (
                <LazyLoadImage 
                    onClick={onClick}
                    onError={addDefaultImg}
                    src={`${Config?.imgUrl}${src}`}
                    style={style} 
                    alt="Image Alt"
                    className={`imgPlug ${className}`}
                    visibleByDefault={load || false}
                    effect="blur"
                />
            );
        }
    }
    
}

export function AddToCart({data, showNum, options = []}) {

    
    
    const { t } = useTranslation();
    const {cartData, successData, siteData, user} = useContext(AppContext); 
	const [cart, setcart] = cartData;
    const [success, setsuccess] = successData;
    const [siteInfo, setsiteInfo] = siteData;
    const [userinfo, setuserinfo] = user;

    let navigate = useNavigate();
    let location = useLocation();

    let cartF = cart?.filter(r => r?._id == data?._id);
    let n = 0;
    if (cartF?.length && cartF[0]?.num) {
        n = cartF[0]?.num;
    }

    const [numb2, setnumb] = useState(n);

    function add(arr) {
        
        let numb = arr?.num || numb2;
        
        if (siteInfo?.settings?.buy_option?.val == 0 && !userinfo?._id) {
            
            navigate("/login", { state: {previousLocation: location } });
            return false;
        }
        
        if (numb <= 0) {
            setsuccess({ error:true,  short: t("carts_error_0") });
            return false;
        }

        let checkQnt = options?.filter(p => p?._id == 'qnt');
        let justOptions = options?.filter(p => p?._id != 'qnt');
        
        if (!checkQnt?.length) {
            numb = arr?.num || numb2
        } else {
            numb = checkQnt[0]?.val;
        }
        
        
        let newData = {
            _id:data?._id,
            full:data?.full,
            img:data?.img,
            pid: data?.pid,
            rivhit_id: data?.rivhit_id,
            price:data?.price?.$numberDecimal,
            qnt:data?.qnt,
            title:data?.title,
            num:numb,
            selectedOptions:justOptions || [],
        };
        

        setcart(p => p?.length ? [...p?.filter(r => r?._id != newData?._id && JSON.stringify(newData?.selectedOptions) == JSON.stringify(r?.selectedOptions)), newData] : [newData]);
        if (!arr?.hide) {
            setsuccess({ short: t("add_to_cart_success") });
        }
    }

    
    function numberSelected(v) {

        if (siteInfo?.settings?.buy_option?.val == 0 && !userinfo?._id) {
            navigate("/login", { state: {previousLocation: location } });
            return false;
        } 
        if (v) {
            setnumb(v);
            add({ hide: true, num: v });
        } else {
            setnumb(0);
            setcart(p => p?.filter(r => r?._id != data?._id));
        }

    }


    return (
        <>
            {showNum ? 
            
                <div className='addToCartBoxWith'>
                    <NumberCart onChange={(v) => numberSelected(v?.val)} qnt={data?.data} value={numb2}/>
                    {/* <a onClick={add} className='btn addToCartBtn'>
                        <MdAddShoppingCart />{t("add_to_cart")}
                    </a> */}
                </div>
            :
                <a onClick={add} className='btn addToCartBtn'>
                    <MdAddShoppingCart />{t("add_to_cart")}
                </a>
            }
        </>
    );
}

export function GoogleLogin({ redirect }) {

    const { t } = useTranslation();
    const {cartData, successData, user} = useContext(AppContext); 
	const [cart, setcart] = cartData;
    const [success, setsuccess] = successData;
    const [userinfo, setuserinfo] = user;

    let navigate = useNavigate();

    const googleLogin = useGoogleLogin({
		onSuccess: async tokenResponse => {
			tokenResponse.type = "google";
			let res = await user_login(tokenResponse);
			if (res?.error) {
				if (res?.error == "no_user") {
					navigate("/reg", { state: {previousLocation: { pathname:"/"}, data: res?.data } });
				} else {
					setsuccess({ error: true, short: t("error",  { returnObjects: true })[res?.error] });
				}

			} else {
				setsuccess({ short: t("login_success") });
				setuserinfo(res?.userinfo);

                
				setTimeout(() => {
                    window.history.replaceState(null, null, "/");
					navigate("/", { replace: true, });
				}, 2500);
			}
			
		},
		onError: e => console.log("error", e),
		// flow: 'auth-code',
	});


    return (
        <button type='button' onClick={()=> googleLogin()} className='btn google'>
            <img src={Google} /> {t("login_google_reg")}
        </button>
    );

}